import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function SquareIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 9} height={height || 17} viewBox="0 0 9 17" {...props}>
      <text
        data-name="\uF304"
        transform="translate(-266.371 -43.381) translate(266.371 57.381)"
        fill={color || "#979797"}
        fontSize={13}
        fontFamily="SegoeUI, Segoe UI"
      >
        <tspan x={0} y={0}>
          {"\uF304"}
        </tspan>
      </text>
    </svg>
  );
}
